<template>
  <div
    class="inline-flex relative dropdown mt-5 brdr-2 c-white"
    data-testid="accountButton"
    tabindex="0"
    role="button"
    @click.self="showMenu = true"
    @mouseover="showMenu = true"
    @mouseout="showMenu = false"
  >
    <button
      type="button"
      class="c-bg-transparent brdr-none p0"
      :aria-label="$t('Open my account')"
    >
      <i class="icon icon-ev-user block" />
    </button>

    <no-ssr>
      <div
        :class="['dropdown-content c-bg-white align-left lh20 regular', !showMenu ? 'dropdown-content__hidden' : '']"
      >
        <div
          v-show="currentUser"
          class="py5 px10"
        >
          <div
            v-for="(page, index) in navigation"
            :key="index"
            @click="notify(page.title)"
          >
            <router-link
              class="no-underline block py10 px10 c-black brdr-bottom-1 c-brdr-grayscale-lighter"
              :to="localizedRoute(page.link)"
              @click.native="showMenu = false"
            >
              {{ page.title }}
            </router-link>
          </div>
          <a
            class="no-underline block py10 px10 logout"
            @click.prevent="logout();showMenu = false"
          >
            {{ $t('Logout') }}
          </a>
        </div>
        <div
          v-show="!currentUser"
          class="py5 px10"
        >
          <div>
            <a
              class="no-underline block py10 px10 c-black brdr-bottom-1 c-brdr-grayscale-lighter login"
              @click="goToAccount();showMenu = false"
            >
              {{ $t('Login') }}
            </a>
            <a
              class="no-underline block py10 px10 c-black create-account"
              @click="goToRegisterPage();showMenu = false"
            >
              {{ $t('Create account') }}
            </a>
          </div>
        </div>
      </div>
    </no-ssr>
  </div>
</template>

<script>
import NoSSR from 'vue-no-ssr'
import AccountIcon from '@vue-storefront/core/compatibility/components/blocks/Header/AccountIcon'

export default {
  components: {
    'no-ssr': NoSSR
  },
  mixins: [AccountIcon],
  data () {
    return {
      showMenu: false,
      navigation: [
        { title: this.$t('Your account'), link: '/my-account' },
        { title: this.$t('Your orders'), link: '/my-account/orders' }
      ]
    }
  },
  methods: {
    notify (title) {
      if (title === 'My loyalty card' || title === 'My product reviews') {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'warning',
          message: this.$t('This feature is not implemented yet! Please take a look at https://github.com/DivanteLtd/vue-storefront/issues for our Roadmap!'),
          action1: { label: this.$t('OK') }
        })
      }
    },
    goToRegisterPage () {
      this.$store.commit('ui/setAuthElem', 'register')
      this.$bus.$emit('modal-show', 'modal-signup')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-icon-hover: color(black);

.dropdown {
  border-radius: 12px;
  padding: 2px;

  &:hover {
    background-color: color(white);
    border-radius: 12px 12px 0 0;

    button {
      i {
        background-image: url("/assets/icons/user-black.png");
      }
    }
  }

  button {
    pointer-events: none;
    height: 40px;
    width: 40px;

    i {
      height: 30px;
      width: 30px;
      margin: 0 auto;
    }
  }

  .dropdown-content {
    display: none;
    position: absolute;
    right: -2px;
    top: 100%;
    width: 161px;
    z-index: 20;
    border-radius: 12px 0 12px 12px;
  }

  @media (min-width: 768px) {
    &:hover .dropdown-content:not(.dropdown-content__hidden),
    &:focus .dropdown-content:not(.dropdown-content__hidden) {
      display: block;
    }

    &:focus-within {
      .dropdown-content:not(.dropdown-content__hidden) {
        display: block;
      }
    }
  }
}
</style>
